module.exports = __webpack_public_path__ + "img/table-addcb-icon.1aef6e3a.svg";